<div class="ice-card" [ngClass]="[type + '-card']">
  <ng-content />
</div>
